"use client";
import { useState } from "react";
import { Button } from "./button";
import { Copy, Check } from "lucide-react";
export const CopyToClipboardButton = ({ text, id, copiedId, setCopiedId, durationMs = 2000, children, ...buttonProps }) => {
    const [localCopied, setLocalCopied] = useState(false);
    const isCopied = copiedId && setCopiedId && id ? copiedId === id : localCopied;
    const handleCopy = async () => {
        await navigator.clipboard.writeText(text);
        if (copiedId && setCopiedId && id) {
            setCopiedId(id);
            setTimeout(() => setCopiedId(""), durationMs);
        }
        else {
            setLocalCopied(true);
            setTimeout(() => setLocalCopied(false), durationMs);
        }
    };
    return (<Button {...buttonProps} onClick={handleCopy}>
      {isCopied ? <Check className="h-4 w-4"/> : <Copy className="h-4 w-4"/>}
      {children}
    </Button>);
};
